import {scenarioGroupActionTypes} from './../constants';
export const addScenarioGroupFromAPI = ( scenarioGroup ) => {
    return {
        type: scenarioGroupActionTypes().addScenario,
        scenarioGroup: scenarioGroup.data,
        pages: scenarioGroup.pages,
        currentPage: scenarioGroup.current_page
    }
}

export const editScenarioGroupData = ( scenarioGroup ) => {
    return {
        type:scenarioGroupActionTypes().editScenario,
        scenarioGroup
    }
}

export const deleteScenarioGroupData = ( { scenario_id } ) => {
    return {
        type:scenarioGroupActionTypes().deleteScenario,
        scenario_id
    }
}
